import React, { useState } from "react";
import { champPath } from "../misc/Static";
import Champ from "../images/Champ";
import Elo from "../misc/Elo";
import Item from "../images/Item";
import KeyStonePlus from "../misc/KeystonePlus";
import MatchExtraDetails from "./MatchExtraDetails";
import { Link } from "react-router-dom";
import styles from "./MatchRowTiny.module.css";

export const MatchRowTiny = ({ match, p, width }) => {
  const [active, setActive] = useState(false);
  const expandDetails = () => setActive(!active);
  return (
    <>
      <div className={styles.wrapper}>
        <div>
          <div className={styles.row1}>
            <div className={styles.champ}>
              <a
                href={
                  "https://lolalytics.com/lol/" +
                  champPath(match.champion[p]) +
                  "/build/"
                }
              >
                <Champ type="champ50b" id={match.champion[p]} />
              </a>
              <div>{match.champLevel[p]}</div>
            </div>
            <div className={styles.runes}>
              <KeyStonePlus
                keystone={match.perk0[p]}
                secondary={match.perkSubStyle[p]}
              />
            </div>

            <div className={styles.summoner}>
              <Link to={match.pathName[p]}>
                <div className={styles.name}>{match.summonerName[p]}</div>
              </Link>
            </div>
            <div className={styles.kda}>
              <span>{match.kills[p]}</span> / <span>{match.deaths[p]}</span> /{" "}
              <span>{match.assists[p]}</span>
            </div>
          </div>
          <div className={styles.row2}>
            <Elo
              tier={match.tier[p].toLowerCase()}
              division={match.division[p]}
            />
            <div className={styles.items}>
              <div>
                {match.items[p].map((item, i) => (
                  <React.Fragment key={"item" + i}>
                    {item === 0 && <div className={styles.placeholder}></div>}
                    {item > 0 && <Item type="item24r" id={item} />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.expand} onClick={expandDetails}>
          {active ? "-" : "+"}
        </div>
      </div>
      {active && <MatchExtraDetails match={match} pid={p} width={width} />}
    </>
  );
};
export default MatchRowTiny;
